import { NavigationListItemInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';
import Container from '../container/container';
import LinkRenderer from '../link/link-renderer';
import MenuDrawerAccordions from './menu-drawer-accordions';

export interface NavigationItemProps extends NavigationListItemInterface {}

export function MenuDrawerNavigationListItem({ link, subMenu, theme }: NavigationItemProps) {
  const hasMenu = subMenu && !isEmpty(subMenu);

  return (
    <div className="empty:hidden">
      {hasMenu && (
        <Container>
          <div className="pt-6">
            <div className="space-y-4">
              <div className="flex items-center justify-center">
                {link && (
                  <LinkRenderer
                    cta={{
                      ...link,
                      className: '!text-2xl font-bold',
                    }}
                  />
                )}
              </div>
              <MenuDrawerAccordions subMenu={subMenu} theme={theme} />
            </div>
          </div>
        </Container>
      )}
    </div>
  );
}

export default MenuDrawerNavigationListItem;
